import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

import api from "../../services/api";

const FONT = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

const useStyles = makeStyles(theme => ({
  wrap: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    background: theme.app ? theme.app.chatBg : "#F6F7F9",
    fontFamily: FONT,
    color: theme.app ? theme.app.textSecondary : "#5B6470",
  },
  msg: { fontSize: 14 },
  err: { fontSize: 14, color: theme.app ? theme.app.danger : "#C0453B", textAlign: "center", maxWidth: 360 },
  link: { color: theme.app ? theme.app.dark : "#2C353D", fontWeight: 600, cursor: "pointer", textDecoration: "underline" },
}));

// SSO da BR DID: o portal deles redireciona para /sso?token=<jwt>. Trocamos o
// token pela nossa sessão (cookie de refresh) e recarregamos em "/" — o bootstrap
// do AuthProvider (/auth/refresh) assume daí. Com intent=mcp, vai pra tela de
// habilitar o MCP em vez do studio.
const Sso = () => {
  const classes = useStyles();
  const location = useLocation();
  const [error, setError] = useState("");

  useEffect(() => {
    const q = new URLSearchParams(location.search);
    const token = q.get("token");
    const intent = q.get("intent");
    const did = q.get("did");
    if (!token) {
      setError("Link de acesso inválido (sem token).");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/sso", { token });
        // intent=mcp → tela de autorizar/habilitar o MCP (repassa o did da URL);
        // senão, o studio.
        const dest = intent === "mcp" ? `/conectar-mcp${did ? `?did=${encodeURIComponent(did)}` : ""}` : "/";
        window.location.replace(dest);
      } catch (e) {
        setError((e.response && e.response.data && e.response.data.error) || "Não foi possível entrar.");
      }
    })();
  }, [location.search]);

  return (
    <div className={classes.wrap}>
      {error ? (
        <>
          <div className={classes.err}>{error}</div>
          <span className={classes.link} onClick={() => window.location.replace("/login")}>
            Ir para o login
          </span>
        </>
      ) : (
        <>
          <CircularProgress size={28} />
          <div className={classes.msg}>Entrando…</div>
        </>
      )}
    </div>
  );
};

export default Sso;
